import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ArquivoExtratoComponent} from './arquivo-extrato.component';
import {AssociarLinhasComponent} from './associar-linhas/associar-linhas.component';
import {AuthGuard} from 'src/app/guards/auth.guard';
import {AcessoModuloResolver} from 'src/app/guards/acesso-modulo.resolve';
import {Modulos} from 'src/app/core/modulos';

const routes: Routes = [
    {
        path: 'arquivo-extrato',
        component: ArquivoExtratoComponent,
        canActivate: [AuthGuard],
        resolve: {perfilAcesso: AcessoModuloResolver},
        data: {
            modulo: Modulos.ARQUIVO_EXTRATO,
            moduloSecundario: Modulos.ASSOCIAR_LINHA_EXTRATO
        },
    },
    {
        path: 'arquivo-extrato/associar/:id',
        component: AssociarLinhasComponent,
        canActivate: [AuthGuard],
        resolve: {perfilAcesso: AcessoModuloResolver},
        data: {
            modulo: Modulos.ASSOCIAR_LINHA_EXTRATO,
            moduloSecundario: Modulos.CONJUNTO_CATEGORIA_CONTABIL
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ArquivoExtratoRoutingModule {
}
